import { createReducer, on } from '@ngrx/store';
import { Entities, SortCriteria, Troop, UserType } from '../../models';
import * as lookupActions from '../actions/lookup.actions';
import { ApplicantDocumentType, ApplicationType, CodeValue, Country, County, EducationType, JobVacancySource, LawEnforcementTestType, MilitaryDischargeType, PATLocation, PATResult, Permission, PolygraphDisqualificationReason,  Prefix, PsychologicalResult, Race, Role, RolePermission, Sex, StateAddress, Suffix, VeteranPreferenceClaimCategory, WaiverDocument } from './../../../shared/models/lookup.models';

export interface State {
  isStateLoaded: boolean;
  state: Entities<StateAddress>;
  isCountyLoaded: boolean
  county: Entities<County>;
  isCountryLoaded: boolean;
  country: Entities<Country>;
  isRaceLoaded: boolean;
  race: Entities<Race>;
  isSexLoaded: boolean;
  sex: Entities<Sex>;
  isPrefixLoaded: boolean;
  prefix: Entities<Prefix>;
  isSuffixLoaded: boolean;
  suffix: Entities<Suffix>;
  isMilitaryDischargeTypeLoaded: boolean;
  militaryDischargeType: Entities<MilitaryDischargeType>;
  isJobVacancySourceLoaded: boolean;
  jobVacancySource: Entities<JobVacancySource>;
  isVeteranPreferenceClaimCategoryLoaded: boolean;
  veteranPreferenceClaimCategory: Entities<VeteranPreferenceClaimCategory>;
  isUserTypeLoaded: boolean;
  userType: Entities<UserType>;
  isTroopLoaded: boolean;
  troop: Entities<Troop>;
  isApplicantDocumentTypeLoaded: boolean;
  applicantDocumentType: Entities<Troop>;
  isRoleLoaded: boolean;
  role: Entities<Role>;
  isPermissionLoaded: boolean;
  permission: Entities<Permission>;
  isRolePermissionLoaded: boolean;
  rolePermission: Entities<RolePermission>;
  isApplicationTypeLoaded: boolean;
  applicationType: Entities<ApplicationType>;
  patLocation: Entities<PATLocation>;
  isPolygraphDisqualificationReasonLoaded: boolean;
  polygraphDisqualificationReason: Entities<PolygraphDisqualificationReason>;
  isPsychologicalResultLoaded: boolean;
  psychologicalResult: Entities<PsychologicalResult>;
  isPATResultLoaded: boolean;
  patResult: Entities<PATResult>;
  isLawEnforcementTestTypeLoaded: boolean;
  lawEnforcementTestTypeResult: Entities<PATResult>;
  isEducationTypeLoaded: boolean;
  educationType: Entities<EducationType>;
  isWaiverDocumentLoaded: boolean;
  waiverDocument: Entities<WaiverDocument>;
  isCodeValueLoaded: boolean;
  codeValueList: Entities<CodeValue>;
  //polygraphLocation: Entities<PolygraphLocation>;
  sortCriteriaPATLocation: Partial<SortCriteria>;
  //sortCriteriaPolygraphLocation: Partial<SortCriteria>;
}

const initialState: State = {
  isStateLoaded: false,
  state: {},
  isCountyLoaded: false,
  county: {},
  isCountryLoaded: false,
  country: {},
  isRaceLoaded: false,
  race: {},
  isSexLoaded: false,
  sex: {},
  isPrefixLoaded: false,
  prefix: {},
  isSuffixLoaded: false,
  suffix: {},
  isMilitaryDischargeTypeLoaded: false,
  militaryDischargeType: {},
  isJobVacancySourceLoaded: false,
  jobVacancySource: {},
  isVeteranPreferenceClaimCategoryLoaded: false,
  veteranPreferenceClaimCategory: {},
  isUserTypeLoaded: false,
  userType: {},
  isTroopLoaded: false,
  troop: {},
  isApplicantDocumentTypeLoaded: false,
  applicantDocumentType: {},
  isRoleLoaded: false,
  role: {},
  isPermissionLoaded: false,
  permission: {},
  isRolePermissionLoaded: false,
  rolePermission: {},
  isApplicationTypeLoaded: false,
  applicationType: {},
  patLocation: {},
  isPolygraphDisqualificationReasonLoaded: false,
  polygraphDisqualificationReason: {},
  isPsychologicalResultLoaded: false,
  psychologicalResult: {},
  isPATResultLoaded: false,
  patResult: {},
  isLawEnforcementTestTypeLoaded: false,
  lawEnforcementTestTypeResult: {},
  isEducationTypeLoaded: false,
  educationType: {},
  isWaiverDocumentLoaded: false,
  waiverDocument: {},
  isCodeValueLoaded: false,
  codeValueList: {},
  //polygraphLocation: {},
  sortCriteriaPATLocation: {},
  //sortCriteriaPolygraphLocation: {},
};

export const reducer = createReducer(
  initialState,
  on(lookupActions.LoadStateApiSuccess, (state, action) => ({
    ...state,
    isStateLoaded: true,
    state: action.data.reduce<Entities<StateAddress>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadCountyApiSuccess, (state, action) => ({
    ...state,
    isCountyLoaded: true,
    county: action.data.reduce<Entities<County>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadCountryApiSuccess, (state, action) => ({
    ...state,
    isCountryLoaded: true,
    country: action.data.reduce<Entities<Country>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadRaceApiSucess, (state, action) => ({
    ...state,
    isRaceLoaded: true,
    race: action.data.reduce<Entities<Race>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadSexApiSuccess, (state, action) => ({
    ...state,
    isSexLoaded: true,
    sex: action.data.reduce<Entities<Sex>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPrefixApiSucess, (state, action) => ({
    ...state,
    isPrefixLoaded: true,
    prefix: action.data.reduce<Entities<Prefix>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadSuffixApiSucess, (state, action) => ({
    ...state,
    isSuffixLoaded: true,
    suffix: action.data.reduce<Entities<Suffix>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadMilitaryDischargeTypeApiSucess, (state, action) => ({
    ...state,
    isMilitaryDischargeTypeLoaded: true,
    militaryDischargeType: action.data.reduce<Entities<MilitaryDischargeType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadJobVacancySourceApiSucess, (state, action) => ({
    ...state,
    isJobVacancySourceLoaded: true,
    jobVacancySource: action.data.reduce<Entities<JobVacancySource>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadVeteranPreferenceClaimCategoryApiSucess, (state, action) => ({
    ...state,
    isVeteranPreferenceClaimCategoryLoaded: true,
    veteranPreferenceClaimCategory: action.data.reduce<Entities<VeteranPreferenceClaimCategory>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadUserTypeApiSucess, (state, action) => ({
    ...state,
    isUserTypeLoaded: true,
    userType: action.data.reduce<Entities<UserType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadTroopApiSucess, (state, action) => ({
    ...state,
    isTroopLoaded: true,
    troop: action.data.reduce<Entities<Troop>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadApplicantDocumentTypeApiSucess, (state, action) => ({
    ...state,
    isApplicantDocumentTypeLoaded: true,
    applicantDocumentType: action.data.reduce<Entities<ApplicantDocumentType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPATLocationApiSucess, (state, action) => ({
    ...state,
    patLocation: action.data.reduce<Entities<PATLocation>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPolygraphDisqualificationReasonsApiSucess, (state, action) => ({
    ...state,
    isPolygraphDisqualificationReasonLoaded : true,
    polygraphDisqualificationReason: action.data.reduce<Entities<PolygraphDisqualificationReason>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPsychologicalResultApiSucess, (state, action) => ({
    ...state,
    isPsychologicalResultLoaded: true,
    psychologicalResult: action.data.reduce<Entities<PsychologicalResult>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPATResultApiSucess, (state, action) => ({
    ...state,
    isPATResultLoaded: true,
    patResult: action.data.reduce<Entities<PATResult>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadRoleApiSucess, (state, action) => ({
    ...state,
    isRoleLoaded: true,
    role: action.data.reduce<Entities<Role>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadPermissionApiSucess, (state, action) => ({
    ...state,
    isPermissionLoaded: true,
    permission: action.data.reduce<Entities<Permission>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadRolePermissionApiSucess, (state, action) => ({
    ...state,
    isRolePermissionLoaded: true,
    rolePermission: action.data.reduce<Entities<RolePermission>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadApplicationTypeApiSucess, (state, action) => ({
    ...state,
    isRolePermissionLoaded: true,
    applicationType: action.data.reduce<Entities<ApplicationType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadEducationTypeApiSucess, (state, action) => ({
    ...state,
    isEducationTypeLoaded: true,
    educationType: action.data.reduce<Entities<EducationType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadWaiverDocumentApiSucess, (state, action) => ({
    ...state,
    isWaiverDocumentLoaded: true,
    waiverDocument: action.data.reduce<Entities<WaiverDocument>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadLawEnforcementTestTypeApiSucess, (state, action) => ({
    ...state,
    isLawEnforcementTestTypeLoaded: true,
    lawEnforcementTestTypeResult: action.data.reduce<Entities<LawEnforcementTestType>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
  on(lookupActions.LoadCodeValuesApiSucess, (state, action) => ({
    ...state,
    isCodeValueLoaded: true,
    codeValueList: action.data.reduce<Entities<CodeValue>>((obj, item) => { return { ...obj, [item.id]: item } }, {}),
  })),
);

